import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=54a470fb&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a470fb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54a470fb')) {
      api.createRecord('54a470fb', component.options)
    } else {
      api.reload('54a470fb', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=54a470fb&scoped=true&", function () {
      api.rerender('54a470fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2W11z5WKS4bCC/JS/comp/Voucher-Unit.vue"
export default component.exports